<template>
    <v-autocomplete
        v-model="result"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        :rules="rules"
        color="white"
        item-text="name"
        item-value="id"
        :label="$t('formFleet.forms.parentFleet.name')"
        :placeholder="$t('formFleet.forms.parentFleet.placeholder')"
        outline
        single-line
        deletable-chips
        return-object
        clearable
        :cache-items="cacheItems"
        :multiple="multiple"
        :small-chips="chips"
        :disabled="disabled || !hasAllRoles(['FleetView'])"
    >
    </v-autocomplete>
</template>

<script>
import FleetApi from '@/api/FleetApi'

const fleetApi = new FleetApi()

export default {
    name: 'FleetAutocomplete',
    data () {
        return {
            isLoading: false,
            items: [],
            entries: [],
            search: null
        }
    },
    props: {
        fleetId: {
            type: String,
            default: ''
        },
        value: {
            type: [Object, Array, null]
        },
        selected: {
            type: [Object, null]
        },
        disabled: {
            type: Boolean,
            default: false
        },
        cacheItems: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        chips: {
            type: Boolean,
            default: false
        },
        organization: {
            type: [Object, Array],
            required: false,
            default: null
        },
        rules: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        search: {
            handler: function (value, oldVal) {
                this.getFleets(value)
            },
            deep: true
        },
        organization: {
            handler: function (value, oldVal) {
                this.getFleets(this.search)
                this.isDirty = true
            },
            deep: true
        }
    },
    computed: {
        result: {
            get () {
                if (null != this.value && this.items.indexOf(this.value) && !Array.isArray(this.value)) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.items.push(this.value)
                }

                if (Array.isArray(this.value) && this.multiple) {
                    for (const item of this.value) {
                        if (!this.items.includes(item) && null != item) {
                            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                            this.items.push(item)
                        }
                    }
                }

                if (null != this.value && this.multiple) {
                    return Array.isArray(this.value) ? this.value : [this.value]
                } else {
                    return this.value
                }
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    mounted () {
        this.getFleets()
    },
    methods: {
        async getFleets (value) {
            if (!this.hasAllRoles(['FleetView'])) return

            const response = await fleetApi.getFleetList({
                fleetName: value,
                organization: this.organization ? this.organization : null,
                page: 1,
                perPage: 100
            })
            this.items = this.filterFleets(response.payload.items)
        },
        filterFleets (items) {
            return items.filter(function (value) {
                return value.id !== this
            }, this.fleetId)
        }
    }
}
</script>

<style scoped>

</style>
